import axios from "axios";
const NO_CONTENT = 204;
const UNAUTHORIZED = 401;
const CancelToken = axios.CancelToken;
const _pendingRequests: any = {};
const BASE_URL = "";

// Cancelling pending requests after timeout
const abortPendingRequests = (key: string | number) => {
  if (_pendingRequests[key]) {
    _pendingRequests[key]('REQUEST_CANCELLED');
    _pendingRequests[key] = null;
  }
};

// Invalid token authorization
const isInvalidToken = (response: any) => {
  if (response.status !== UNAUTHORIZED) {
    return false;
  }

  const authHeader = response.headers.get('WWW-Authenticate') || '';

  return authHeader.includes('invalid_token');
};

const processResponse = (res: any) => {
  if (isInvalidToken(res)) {
    return { data: {} };
  }

  if (res.status === NO_CONTENT) {
    const response = Object.assign({}, res, { data: {} });
    return response;
  }
  return res;
};

// Check if response is empty
const isEmpty = (jsonResponse: any) => {
  if (!Object.keys(jsonResponse).length) {
    return true;
  }
  return false;
}
// functionality to handle api response
const handleResponse = (key: string | number, response: any, jsonResponse: any) => {
  const jsonRes = isEmpty(jsonResponse) ? {} : jsonResponse;
  const { status } = response;
  const { errors } = Object.assign({}, jsonRes);
  const resp = {
    status,
    body: jsonResponse,
    errors,
    headers: response.headers,
  };
  return resp;
};

// Headers to be set for each api call
export const API = {
  getHeaders(accessToken: string | null, userCredentials: any, headers?: any) {
    if (headers) {
      headers['Content-Type'] = 'application/json';
      return headers;
    }
    else {
      return {
        'Content-Type': 'application/json'
      };
    }
  },

  // Creating api request setting proper headers
  makeRequest(path: string, key: string | number, reqInit: any, userCredentials?: any, headerData?: any) {
    // abortPendingRequests(key);
    const accessToken = localStorage.getItem("authToken") ? localStorage.getItem("authToken") : "";
    let jsonUserCred = '';
    if (userCredentials) {
      delete userCredentials.isVerified;
      jsonUserCred = JSON.stringify(userCredentials);
    }
    let headers: any;
    if (headerData) {
      headers = this.getHeaders(accessToken, jsonUserCred, headerData);
    }
    else {
      headers = this.getHeaders(accessToken, jsonUserCred);
    }
    const init = Object.assign({}, reqInit, { headers });
    return axios({
      url: path,
      ...init,
      timeout: 30000,
      cancelToken: new CancelToken(function executor(c: any) {
        _pendingRequests[key] = c;
      }),
    })
      .then((res: any) => processResponse(res))
      .then((res: any) => {
        return handleResponse(key, res, res.data);
      })
      .catch((err: any) => {
        if (err?.message === "REQUEST_CANCELLED") {
          return Promise.reject(err);
        } else {
          return err;
        }
      });
  },

  // query params to be passed along with api call
  getParams(queryParams = {}) {
    return queryParams;
  },

  // GET api call
  async get(path: string, key: string | number, queryParams: any, options?: any) {
    const getData = {
      method: 'GET',
      params: this.getParams(queryParams)
    };
    const pathLoc = path;

    if (options?.headers) {
      return this.makeRequest(pathLoc, key, getData, {}, options?.headers);
    }
    else {
      return this.makeRequest(pathLoc, key, getData);
    }
  },

  // Post api call
  async post(path: string, key: string | number, body: any, options?: any) {
    const postData = {
      method: 'POST',
      data: options?.isParams ? undefined : body,
      params: this.getParams(options?.isParams ? body : undefined)
    };
    const pathLoc = path;
    if (options?.headers) {
      return this.makeRequest(pathLoc, key, postData, {}, options?.headers);
    }
    else {
      return this.makeRequest(pathLoc, key, postData);
    }
  },

  // PUT api call
  async put(path: string, key: string | number, body: any, options?: any) {
    const putData = {
      method: 'PUT',
      data: body,
      params: this.getParams()
    };
    const pathLoc = options?.takeFullPath ? path : `${BASE_URL}/${path}`
    return this.makeRequest(`${BASE_URL}/${path}`, key, putData);
  },

};